export const icMinus = "../../../assets/icons/ic-minus.svg";
export const icPlus = "../../../assets/icons/ic-plus.svg";
export const icClock = "../../../assets/icons/ic-clock.svg";
export const icArrowDown = "../../../assets/icons/ic-arrow-down.svg";
export const icArrowDown2 = "../../../assets/icons/arrow-down.svg";
export const icNextBlue = "../../../assets/icons/ic-next-blue.svg";
export const icWarnRed = "../../../assets/icons/ic-warn-red.svg";

export const icUserOutline = "../../../assets/icons/ic-user-outline.svg";
export const icLangOutline = "../../../assets/icons/ic-lang-outline.svg";
export const icCartOutline =
  "../../../assets/images/icons/shopping-card-outline.svg";
export const icQuestion = "../../../assets/icons/question.svg";
export const icCheck = "../../../assets/icons/check.svg";
export const icWarningPopup = "../../../assets/icons/warning-popup.svg";

export const icCartOutlineBlack =
  "../../../assets/images/icons/shopping-card.svg";
export const icShareOutline = "../../../assets/icons/ic-share-outline.svg";
export const icLoveOutline = "../../../assets/icons/ic-love-outline.svg";
export const icLovedOutline = "../../../assets/icons/ic-loved-outline.svg";
export const icBack = "../../../assets/icons/ic-back.svg";
export const icBackArrow = "../../../assets/icons/ic-back-arrow.svg";
export const icBackArrowBlack = "../../../assets/icons/ic-back-arrow-black.svg";
export const icCart = "../../../assets/images/icons/shopping-card.svg";

export const icHome = "../../../assets/images/icons/ic-home.svg";
export const icHomeActive = "../../../assets/images/icons/ic-home-active.svg";
export const icCity = "../../../assets/images/icons/ic-city.svg";
export const icCityActive = "../../../assets/images/icons/ic-city-active.svg";
export const icPass = "../../../assets/images/icons/ic-pass.svg";
export const icPassActive = "../../../assets/images/icons/ic-pass-active.svg";
export const icBooking = "../../../assets/images/icons/ic-booking.svg";
export const icBookingActive =
  "../../../assets/images/icons/ic-booking-active.svg";
export const icMore = "../../../assets/images/icons/ic-more.svg";
export const icMoreActive = "../../../assets/images/icons/ic-more-active.svg";

export const icClose = "../../../assets/icons/ic-close.svg";
export const icCloseRed = "../../../assets/icons/ic-close-red.svg";
export const icPremiumPlusTag = "../../../assets/icons/premium-plus-tag.svg";
export const icDelete = "../../../assets/icons/ic-delete.svg";
export const icDelete2 = "../../../assets/icons/ic-delete2.svg";
export const icDeleteRed = "../../../assets/icons/ic-delete-red.svg";
export const icEdit = "../../../assets/icons/ic-edit.svg";
export const icEdit2 = "../../../assets/icons/ic-edit2.svg";
export const icNew = "../../../assets/icons/ic-new.svg";
